import { useTranslation } from "react-i18next";

export default function IcoLaptop() {
	const { t } = useTranslation();

	return (
		<img
			src="/assets/images/ico-laptop.webp"
			alt={t("strategy_title")}
			loading="eager"
			width="225"
			height="200"
		/>
	);
}
